// noinspection EqualityComparisonWithCoercionJS

import Button from 'components/Button'
import { BrowserView, MobileAndTabletView } from 'components/DeviceDetect'
import Arrow from 'components/Icons/Arrow'
import Filter from 'components/Icons/Filter'
import { CategoriesDesktop } from 'components/Widgets/Categories'
import React, { Fragment, useState } from 'react'
import useInnerPage from 'store/InnerPageProvider'
import {
  CategoryFilter,
  CategoryFilterSection,
  ClearFilterButton,
  FilterTag,
  FilterTags,
} from 'style/Category.style'
import { CategoryBackTitle } from 'style/CategoryList/CategoryList.style'
import { Link } from 'style/Global.style'
import Close2 from '../../Icons/Close2'
import FilterModal from '../FilterModal'
import { Ordering } from '../OrderingAndFilters'
import { PriceFilter } from '../PriceFilter'
import SingleFilter from '../SingleFilter'

const InnerPageLeftSide = props => {
  const [filterOpen, setFilterOpen] = useState(false)
  const { backText, backLink } = props

  const {
    sidebar: { categories, min_price, max_price, attributes },
    clearFilters,
    setDisableAutoFilter,
    onFilter,
  } = useInnerPage()

  const getTags = () => {
    const url = new URL(window.location.href)
    let filter = url.searchParams.get('filters')
    if (!filter) {
      return []
    }
    filter = JSON.parse(filter)
    const tags = []
    for (let fil in filter) {
      const value = filter[fil]
      for (let x in value) {
        tags.push(value[x])
      }
    }
    return tags
  }

  const removeTag = tag => {
    const url = new URL(window.location.href)
    let filter = url.searchParams.get('filters')
    if (!filter) {
      return []
    }
    filter = JSON.parse(filter)
    for (let fil in filter) {
      const value = filter[fil]
      for (let x in value) {
        if (value[x] === tag) {
          value.splice(x, 1)
        }
      }
    }
    url.searchParams.set('filters', JSON.stringify(filter))
    window.location.href = url.href
  }

  const AllFilter = attributes.length ? (
    <CategoryFilter>
      <PriceFilter min={min_price} max={max_price} />
      {(attributes || []).map(attr => {
        return <SingleFilter key={attr.id} attr={attr} />
      })}
    </CategoryFilter>
  ) : (
    <PriceFilter min={min_price} max={max_price} />
  )

  return (
    <div className="flex flex-col ">
      {Array.isArray(categories) ? (
        <Fragment>
          {/*<Categories title={backText} categories={categories} withoutStyles />*/}
          <BrowserView>
            <CategoriesDesktop
              style={{ zIndex: '3' }}
              withoutTitle
              titleComponent={
                <CategoryBackTitle withoutStyles>
                  <Link to={backLink}>
                    <Arrow direction="left" />
                    {backText}
                  </Link>
                </CategoryBackTitle>
              }
              categories={categories}
              withoutStyles
              withoutPadding
              withPaddingBottom={categories.length}
            />
          </BrowserView>
        </Fragment>
      ) : backText && backLink ? (
        <CategoryBackTitle withoutStyles>
          <Link to={backLink}>
            <Arrow direction="left" />
            {backText}
          </Link>
        </CategoryBackTitle>
      ) : null}
      <BrowserView>
        {attributes.length && (
          <ClearFilterButton onClick={() => clearFilters()}>
            გასუფთავება
          </ClearFilterButton>
        )}
        {AllFilter}
        {attributes.length && (
          <ClearFilterButton onClick={() => clearFilters()}>
            გასუფთავება
          </ClearFilterButton>
        )}
      </BrowserView>

      <MobileAndTabletView>
        <CategoryFilterSection>
          <Button
            color="white"
            onClick={() => {
              setFilterOpen(true)
              setDisableAutoFilter(true)
            }}
          >
            <Filter />
            ფილტრი
          </Button>

          <Ordering className={'ordering'} />

          <FilterModal
            open={filterOpen}
            filters={AllFilter}
            attributes={attributes}
            onFilter={onFilter}
            clearFilter={clearFilters}
            onClose={() => {
              setFilterOpen(false)
              setDisableAutoFilter(false)
            }}
          />
        </CategoryFilterSection>
        <FilterTags>
          {getTags().map(tag => {
            return (
              <FilterTag onClick={() => removeTag(tag)}>
                <p>{tag}</p>
                <Close2 color={'white'} width={'8px'} height={'8px'} />
              </FilterTag>
            )
          })}
        </FilterTags>

        {/*{category.title ? (*/}
        {/*  <h1 className="flex justify-start w-full items-center mt-4 text-lg font-bold">*/}
        {/*    {category.title}*/}
        {/*  </h1>*/}
        {/*) : null}*/}
      </MobileAndTabletView>
    </div>
  )
}

export default InnerPageLeftSide
